/** NORA features shown in the drawer — FR / ES based on the URL. */
import { getLocale } from "./ui.strings";

export type Feature = {
  title: string;
  description: string;
  example: string;
};

const FR_FEATURES: readonly Feature[] = [
  {
    title: "Produits → WhatsApp",
    description:
      "Toute recherche ou commande de produit part sur WhatsApp : NORA envoie le lien (SMS de secours) et la conversation continue là-bas, avec images et sélection.",
    example: "Vous avez du Doliprane ?",
  },
  {
    title: "Suivi de commande",
    description: "Où en est votre commande : en préparation, prête à retirer, en cours de livraison, livrée.",
    example: "Ma commande est-elle prête ?",
  },
  {
    title: "Annulation de commande",
    description: "Annule une commande du compte tant qu'elle n'est pas retirée, livrée ou en cours de livraison.",
    example: "Annulez ma commande de vitamine D",
  },
  {
    title: "Horaires en temps réel",
    description: "Ouvert ou fermé en ce moment, horaires du jour, adresse et téléphone.",
    example: "Vous êtes ouverts là ?",
  },
  {
    title: "Pharmacies proches",
    description: "Les pharmacies du réseau les plus proches de votre position.",
    example: "C'est quoi la pharmacie la plus proche ?",
  },
  {
    title: "Services en pharmacie",
    description: "Vaccination, test angine, entretien pharmaceutique, location de matériel, orthopédie.",
    example: "Vous faites les vaccins ? C'est combien ?",
  },
  {
    title: "Prise de rendez-vous",
    description: "Réserve un créneau pour un service et confirme avec une référence.",
    example: "Prenez-moi rendez-vous vaccination jeudi à 14h30",
  },
  {
    title: "Conseils d'usage (notice)",
    description: "Informations générales de la notice : grossesse, allaitement, enfants, alcool — toujours à valider avec le pharmacien.",
    example: "Je peux prendre du Doliprane en étant enceinte ?",
  },
  {
    title: "Message au pharmacien",
    description: "Transmet votre demande au pharmacien quand NORA ne peut pas répondre.",
    example: "Je voudrais laisser un message au pharmacien",
  },
  {
    title: "Fin d appel",
    description: "Dites au revoir et NORA raccroche toute seule, après une formule de politesse.",
    example: "C est tout, merci, au revoir",
  },
  {
    title: "Garde-fous santé",
    description: "Jamais de diagnostic ni de posologie personnalisée — validation par le pharmacien, urgences orientées vers le 15.",
    example: "Quelle dose pour mon enfant ? → renvoi au pharmacien",
  },
];

const ES_FEATURES: readonly Feature[] = [
  {
    title: "Productos → WhatsApp",
    description:
      "Toda búsqueda o pedido de producto pasa a WhatsApp: NORA envía el enlace (SMS de respaldo) y la conversación continúa allí, con imágenes y selección.",
    example: "¿Tienen Gelocatil?",
  },
  {
    title: "Seguimiento de pedido",
    description: "Estado de su pedido: en preparación, listo para recoger, en reparto, entregado.",
    example: "¿Está listo mi pedido?",
  },
  {
    title: "Anulación de pedido",
    description: "Anula un pedido de la cuenta mientras no esté recogido, entregado o en reparto.",
    example: "Anule mi pedido de vitamina D",
  },
  {
    title: "Horarios en tiempo real",
    description: "Abierto o cerrado ahora mismo, horarios del día, dirección y teléfono.",
    example: "¿Están abiertos ahora?",
  },
  {
    title: "Farmacias cercanas",
    description: "Las farmacias de la red más cercanas a su posición.",
    example: "¿Cuál es la farmacia más cercana?",
  },
  {
    title: "Servicios en farmacia",
    description: "Vacunación, test de faringitis, revisión de medicación, alquiler de material, ortopedia.",
    example: "¿Ponen vacunas? ¿Cuánto cuesta?",
  },
  {
    title: "Reserva de cita",
    description: "Reserva un hueco para un servicio y confirma con una referencia.",
    example: "Deme cita para vacunarme el jueves a las 14:30",
  },
  {
    title: "Consejos de uso (prospecto)",
    description: "Información general del prospecto: embarazo, lactancia, niños, alcohol — siempre a validar con el farmacéutico.",
    example: "¿Puedo tomar Frenadol estando embarazada?",
  },
  {
    title: "Mensaje al farmacéutico",
    description: "Transmite su petición al farmacéutico cuando NORA no puede responder.",
    example: "Quisiera dejar un mensaje al farmacéutico",
  },
  {
    title: "Fin de llamada",
    description: "Despídase y NORA cuelga sola, tras una fórmula de cortesía.",
    example: "Nada más, gracias. Adiós",
  },
  {
    title: "Límites de salud",
    description: "Nunca diagnóstico ni posología personalizada — validación del farmacéutico, urgencias al 112.",
    example: "¿Qué dosis para mi hijo? → remite al farmacéutico",
  },
];

export const features: readonly Feature[] = getLocale() === "es" ? ES_FEATURES : FR_FEATURES;
